import { createSlice } from "@reduxjs/toolkit";
import { liveRoomResponseType } from "@/types/common";

export interface initLoginState {
  allCreatorsData: liveRoomResponseType[];
  topCreatorsData: liveRoomResponseType[];
  followedCreatorsData: liveRoomResponseType[];
}

const initLoginState: initLoginState = {
  allCreatorsData: [],
  topCreatorsData: [],
  followedCreatorsData: [],
};
const cacheReducer = createSlice({
  name: "cache",
  initialState: initLoginState,
  reducers: {
    setAllCreatorsData: (loginState, action) => {
      const data = action.payload;
      return {
        ...loginState,
        allCreatorsData: data,
      };
    },
    setTopCreatorsData: (loginState, action) => {
      const data = action.payload;
      return {
        ...loginState,
        topCreatorsData: data,
      };
    },
    setFollowedCreatorsData: (loginState, action) => {
      const data = action.payload;
      return {
        ...loginState,
        followedCreatorsData: data,
      };
    },
  },
});

export const {
  setAllCreatorsData,
  setTopCreatorsData,
  setFollowedCreatorsData,
} = cacheReducer.actions;
// export default reducer;
export default cacheReducer.reducer;
